<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol> </CCol>
            </CRow>
            <!-- Title page -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.exports.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'exports',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.exports.allFields"
                                        :activeFields.sync="
                                            tables.exports.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.exports.items"
                                    :fields.sync="tables.exports.fields"
                                    :items-per-page="tables.exports.rows"
                                    :loading="tables.exports.loading"
                                    :columnFilterValue.sync="
                                        tables.exports.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.exports.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.exports"
                                    :resizable="false"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.exports
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            download(
                                                                tables.exports
                                                                    .itemSelected
                                                                    .uuid
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("download")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.exports.itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'exports',
                                                        item
                                                    )
                                                "
                                            />
                                    </template>
                                    <template #key="{ item }">
                                            <a
                                                href="#"
                                                @click="download(item.uuid)"
                                            >
                                                {{ item.key }}
                                            </a>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-show="tables.exports.items.length > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.exports.page"
                                        :pages="tables.exports.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.exports.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'exports',
                    })
                "
            >
                <template #title> Don't have exports </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'exports',
                            })
                        "
                        @click="cleanFiltersAdvance('exports'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import NoItemsContainer from "~/components/NoItemsContainer";
import CCTable from "~/components/CCTable";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";

/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilTrash,
    cilGroup,
    cilArrowThickFromRight,
} from "@coreui/icons";

export default {
    name: "ProvidersMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        FilterFields,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
        CCTable
    },
    icons: {
        cilPlus,
        cilSettings,
        cilTrash,
        cilGroup,
        cilArrowThickFromRight,
        eraser,
    },
    watch: {
        "tables.exports.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        }
    },
    data() {
        return {
            tables: {
                exports: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            fixed: true,
                            sortable: false,
                            active: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "uuid",
                            label: "uuid",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            _active: false,
                        },
                        {
                            key: "key",
                            label: "Name",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "status",
                            label: "Status",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "created_at",
                            label: "Creation at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "updated_at",
                            label: "Updated at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 5,
                    page: 1,
                    matchResponseCurrentPage: "currentPage",
                    total_pages: 1,
                    matchResponsePages: "pages",
                    loading: true,
                    hover: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    matchResponse: "data",
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                    loadQueryFromUrl: true,
                },
            },
        };
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "exports",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                },
                url: `/exports`,
            });

            this.tables.exports.itemSelected = null;

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        async download(uuid) {
            try {
                this.updatePageLoading(true);
                const resp = await this.fetcher({
                    url: `/exports/${uuid}/download`,
                    method: "POST",
                    baseURL: process.env.VUE_APP_API_SASS,
                });

                const tmpLink = document.createElement("a");
                tmpLink.href = resp.data.downloadLink;
                // document.body.appendChild(tmpLink);
                tmpLink.click();

                this.showMessageSuccess();
            } catch (error) {
                console.log(error);
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
    },
    mounted() {
        this.updateData();
    }
};
</script>

